import { NotetakerPolicy, NotetakerPolicyResponse, NotetakerPolicyUpdatePayload } from "@/schema"

import { ApiContext, apiContextFetch } from "../base"

export async function getBookNotetakerPolicy(context: ApiContext, bookId: string): Promise<NotetakerPolicy> {
  const response = await apiContextFetch<NotetakerPolicyResponse>(context, `books/${bookId}/notetaker_policy`)
  return response.notetaker_policy
}

export async function updateBookNotetakerPolicy(
  context: ApiContext,
  bookId: string,
  payload: NotetakerPolicyUpdatePayload
): Promise<NotetakerPolicy> {
  const response = await apiContextFetch<NotetakerPolicyResponse>(context, `books/${bookId}/notetaker_policy`, {
    method: "PATCH",
    body: JSON.stringify({ notetaker_policy: payload }),
  })
  return response.notetaker_policy
}

export async function getCompanyNotetakerPolicy(context: ApiContext): Promise<NotetakerPolicy> {
  const response = await apiContextFetch<NotetakerPolicyResponse>(context, "company/notetaker_policy")
  return response.notetaker_policy
}

export async function updateCompanyNotetakerPolicy(
  context: ApiContext,
  payload: NotetakerPolicyUpdatePayload
): Promise<NotetakerPolicy> {
  const response = await apiContextFetch<NotetakerPolicyResponse>(context, "company/notetaker_policy", {
    method: "PATCH",
    body: JSON.stringify({ notetaker_policy: payload }),
  })
  return response.notetaker_policy
}
